import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../styles/Blogs.css';
import blogService from '../services/blogService';
import { blogPosts } from '../data/blogData';
import { sanitizeHtmlForRender } from '../utils/sanitizeHtml';

const API_URL = process.env.REACT_APP_API_URL || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5000');

export function IndividualBlog() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBlog = async () => {
      try {
        const data = await blogService.getBlogById(id);
        if (data) {
          setBlog(data);
        } else {
          const fallback = blogPosts.find((b) => String(b.id) === String(id));
          setBlog(fallback || null);
        }
      } catch (error) {
        console.error('Failed to load blog, using fallback', error);
        const fallback = blogPosts.find((b) => String(b.id) === String(id));
        setBlog(fallback || null);
      } finally {
        setLoading(false);
      }
    };

    loadBlog();
  }, [id]);

  const formatDate = (date) => {
    if (!date) return '';
    return new Date(date).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };

  const getImageUrl = (path) => {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    return `${API_URL}${path}`;
  };

  if (loading) {
    return (
      <div className="blogs-container">
        <p>Loading blog...</p>
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="blog-not-found">
        <div className="blogs-container">
          <h1>Blog not found</h1>
          <button className="back-button" onClick={() => navigate('/blogs')}>
            Back to Blogs
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="individual-blog-page">
      <div className="blogs-container">
        <button className="back-button" onClick={() => navigate('/blogs')}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back to Blogs
        </button>
        
        <article className="blog-post-full">
          <div className="blog-post-header">
            <h1>
              {typeof blog.title === 'string' ? (
                <div dangerouslySetInnerHTML={{ __html: sanitizeHtmlForRender(blog.title) }} />
              ) : (
                blog.title
              )}
            </h1>
            {blog.image_url ? (
              <div className="blog-post-header-image-wrap">
                <img src={getImageUrl(blog.image_url)} alt={blog.title} className="blog-post-header-image" />
              </div>
            ) : null}
            <div className="blog-post-meta">
              <span className="blog-author">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                {blog.author || 'Daniella'}
              </span>
              <span className="blog-date">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
                {blog.date || formatDate(blog.published_at)}
              </span>
            </div>
          </div>
          
          <div className="blog-post-content">
            {typeof blog.content === 'string' ? (
              <div dangerouslySetInnerHTML={{ __html: sanitizeHtmlForRender(blog.content) }} />
            ) : (
              blog.content
            )}
          </div>
        </article>
      </div>
    </div>
  );
}
